import styled from 'styled-components';
import { PropsWithChildren } from 'react';
import { colors, Icon } from '@zopauk/react-components';
import { faExclamationCircle } from '@fortawesome/free-solid-svg-icons';

const Tag = styled.div`
  color: ${colors.greyDarkest};
  background-color: ${colors.brandLight};
  padding: 4px 12px;
  border-radius: 6px;
  display: inline-block;
  line-height: 24px;
  font-size: 14px;
  font-weight: 400;
  margin-top: 12px;
  width: fit-content;
`;

export const CardTag = ({ children }: PropsWithChildren) => (
  <Tag>
    <Icon variant={faExclamationCircle} color={colors.brand} className="mr-2" />
    {children}
  </Tag>
);
